<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>CONTENTS</span></p>
<p class="toc-entry"><a href="#/xhtml/ch0104#chapter01">ONE</a></p>
<p class="toc-entry"><a href="#/xhtml/ch0104#chapter02">TWO</a></p>
<p class="toc-entry"><a href="#/xhtml/ch0104#chapter03">THREE</a></p>
<p class="toc-entry"><a href="#/xhtml/ch0104#chapter04">FOUR</a></p>
<p class="toc-entry"><a href="#/xhtml/ch0508#chapter05">FIVE</a></p>
<p class="toc-entry"><a href="#/xhtml/ch0508#chapter06">SIX</a></p>
<p class="toc-entry"><a href="#/xhtml/ch0508#chapter07">SEVEN</a></p>
<p class="toc-entry"><a href="#/xhtml/ch0508#chapter08">EIGHT</a></p>
<p class="toc-entry"><a href="#/xhtml/ch0911#chapter09">NINE</a></p>
<p class="toc-entry"><a href="#/xhtml/ch0911#chapter10">TEN</a></p>
<p class="toc-entry"><a href="#/xhtml/ch0911#chapter11">ELEVEN</a></p>
<p class="toc-entry"><a href="#/xhtml/ch1214#chapter12">TWELVE</a></p>
<p class="toc-entry"><a href="#/xhtml/ch1214#chapter13">THIRTEEN</a></p>
<p class="toc-entry"><a href="#/xhtml/ch1214#chapter14">FOURTEEN</a></p>
<p class="toc-entry"><span href="#/xhtml/ch15" title="Link target outside of Sample">FIFTEEN</span></p>
<p class="toc-entry"><a href="#/xhtml/ch1618#chapter16">SIXTEEN</a></p>
<p class="toc-entry"><a href="#/xhtml/ch1618#chapter17">SEVENTEEN</a></p>
<p class="toc-entry"><a href="#/xhtml/ch1618#chapter18">EIGHTEEN</a></p>
<p class="toc-entry"><a href="#/xhtml/ch1920#chapter19">NINETEEN</a></p>
<p class="toc-entry"><a href="#/xhtml/ch1920#chapter20">TWENTY</a></p>
<p class="toc-entry"><span href="#/xhtml/ch21" title="Link target outside of Sample">TWENTY-ONE</span></p>
<p class="toc-entry"><a href="#/xhtml/ch2227#chapter22">TWENTY-TWO</a></p>
<p class="toc-entry"><a href="#/xhtml/ch2227#chapter23">TWENTY-THREE</a></p>
<p class="toc-entry"><a href="#/xhtml/ch2227#chapter24">TWENTY-FOUR</a></p>
<p class="toc-entry"><a href="#/xhtml/ch2227#chapter25">TWENTY-FIVE</a></p>
<p class="toc-entry"><a href="#/xhtml/ch2227#chapter26">TWENTY-SIX</a></p>
<p class="toc-entry"><a href="#/xhtml/ch2227#chapter27">TWENTY-SEVEN</a></p>
<p class="toc-entry"><a href="#/xhtml/ch2834#chapter28">TWENTY-EIGHT</a></p>
<p class="toc-entry"><a href="#/xhtml/ch2834#chapter29">TWENTY-NINE</a></p>
<p class="toc-entry"><a href="#/xhtml/ch2834#chapter30">THIRTY</a></p>
<p class="toc-entry"><a href="#/xhtml/ch2834#chapter31">THIRTY-ONE</a></p>
<p class="toc-entry"><a href="#/xhtml/ch2834#chapter32">THIRTY-TWO</a></p>
<p class="toc-entry"><a href="#/xhtml/ch2834#chapter33">THIRTY-THREE</a></p>
<p class="toc-entry"><a href="#/xhtml/ch2834#chapter34">THIRTY-FOUR</a></p>
<p class="toc-entry" style="margin-top:20px;"><span href="#/xhtml/biography" title="Link target outside of Sample">A Biography of Brian Freemantle</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1b454339